'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overlay = require('@alicd/next/lib/overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _button = require('@alicd/next/lib/button');

var _button2 = _interopRequireDefault(_button);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Setting = require('./Setting');

var _Setting2 = _interopRequireDefault(_Setting);

var _Footer = require('./Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _Content = require('./Content');

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaskOverlay = function (_React$Component) {
  (0, _inherits3.default)(TaskOverlay, _React$Component);

  function TaskOverlay(props) {
    (0, _classCallCheck3.default)(this, TaskOverlay);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskOverlay.__proto__ || (0, _getPrototypeOf2.default)(TaskOverlay)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(TaskOverlay, [{
    key: '_getSetting',
    value: function _getSetting() {
      return this._getChildrenByType(_Setting2.default);
    }
  }, {
    key: 'getFooterHeight',
    value: function getFooterHeight(ref) {
      ref && (this._footer_ele = ref);
    }
  }, {
    key: '_getFooter',
    value: function _getFooter() {
      var _footer = this._getChildrenByType(_Footer2.default);
      var loading = this.props.loading;
      if (!this.props.showFooter) return _react2.default.createElement('div', null);
      if (!_footer) {
        _footer = _react2.default.createElement(
          'div',
          { className: 'footer', ref: this.getFooterHeight.bind(this), style: { height: this.state.footerHeight } },
          _react2.default.createElement(
            _button2.default,
            { type: 'secondary', onClick: this.onClickCancel.bind(this) },
            this.props.locale.cancel
          ),
          _react2.default.createElement(
            _button2.default,
            { type: 'primary', loading: loading, onClick: this.onClickOK.bind(this) },
            this.props.locale.ok
          )
        );
      } else {
        _footer = _react2.default.createElement(
          'div',
          { className: 'footer', ref: this.getFooterHeight.bind(this), style: { height: this.state.footerHeight } },
          _footer.props.children
        );
      }
      return _footer;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'onClickCancel',
    value: function onClickCancel(e) {
      this.props.onCancel(e);
    }
  }, {
    key: 'onClickOK',
    value: function onClickOK(e) {
      this.props.onOk(e);
    }
  }, {
    key: '_getContent',
    value: function _getContent() {
      return this._getChildrenByType(_Content2.default);
    }
  }, {
    key: '_getChildrenByType',
    value: function _getChildrenByType(type) {
      var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.children;

      if (type) {
        if (children.length > 1) {
          return children.filter(function (item) {
            return item.type === type;
          })[0];
        } else {
          return children.type === type ? children : null;
        }
      } else {
        return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.props.visible === true && !this.state.footerHeight) {
        setTimeout(function () {
          if (_this2._footer_ele) {
            _this2.setState({
              footerHeight: _this2._footer_ele.offsetHeight
            });
          }
        }, 40);
      }

      var _setting = this._getSetting();
      var _content = this._getContent();
      var _footer = this._getFooter();

      if (!_setting && !_content && !this._getChildrenByType(_Footer2.default)) {
        return _react2.default.createElement(
          _overlay2.default,
          this.props,
          _react2.default.createElement(
            'div',
            { className: 'cn-task-overlay', style: { width: this.props.width || 'auto', height: this.props.height || 'auto' } },
            this.props.showTitle !== false ? _react2.default.createElement(
              'div',
              { className: 'title' },
              this.props.title
            ) : null,
            _react2.default.createElement(
              'div',
              { className: 'content', style: { height: 'calc(100% - ' + (this.state.footerHeight + 56) + 'px)', marginBottom: this.state.footerHeight } },
              this.props.children
            ),
            _footer
          )
        );
      } else {
        return _react2.default.createElement(
          _overlay2.default,
          this.props,
          _react2.default.createElement(
            'div',
            { className: 'cn-task-overlay', style: { width: this.props.width || 'auto', height: this.props.height || 'auto' } },
            this.props.showTitle !== false ? _react2.default.createElement(
              'div',
              { className: 'title' },
              this.props.title,
              _react2.default.createElement(
                'span',
                { className: 'setting' },
                this._getSetting()
              )
            ) : null,
            _react2.default.createElement(
              'div',
              { className: 'content', style: { height: 'calc(100% - ' + (this.state.footerHeight + 56) + 'px)', marginBottom: this.state.footerHeight } },
              this._getContent()
            ),
            _react2.default.createElement(
              'div',
              { style: { height: this.state.footerHeight, position: 'absolute', width: '100%', bottom: 0 } },
              this._getFooter()
            )
          )
        );
      }
    }
  }]);
  return TaskOverlay;
}(_react2.default.Component);

TaskOverlay.propTypes = {
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  onOk: _propTypes2.default.func,
  onCancel: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  showTitle: _propTypes2.default.bool,
  showFooter: _propTypes2.default.bool,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};
TaskOverlay.defaultProps = {
  align: 'cc cc',
  hasMask: true,
  visible: false,
  loading: false,
  showTitle: true,
  showFooter: true,
  onOk: function onOk() {},
  onCancel: function onCancel() {}
};


TaskOverlay.Setting = _Setting2.default;
TaskOverlay.Footer = _Footer2.default;
TaskOverlay.Content = _Content2.default;

exports.default = TaskOverlay;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-task-overlay@0.0.22@@alicd/crui-task-overlay/lib/TaskOverlay.js
// module id = 712
// module chunks = 0